export const GHOST_SEAT_SIZE = 20;
export const SEAT_SPACE = 10;

export const ENTITY_TYPES = {
    TEXT: 'TEXT',
    ROW: 'ROW',
    SHAPE: 'SHAPE',
    SEAT: 'SEAT',
    PIT: 'PIT',
    IMAGE: 'IMAGE'
};

export const TOOL_PAN = 'pan';
export const TOOL_SELECTION = 'selection';
export const TOOL_ROW = 'entity';
export const TOOL_TEXT = 'text';
export const TOOL_SHAPE = 'shape';
export const TOOL_PIT = 'pit';
